import { styled } from '@attentive-platform/stem-ui';

const skipLayoutProps = prop => !['top', 'left', 'width', 'maxHeight'].includes(prop);

export const CompanyMenu = styled('div', { shouldForwardProp: skipLayoutProps })(({ top, left, width, maxHeight }) => ({
  position: 'fixed',
  top,
  left,
  width,
  maxHeight,
  zIndex: 2000,
  overflow: 'auto',
  borderRadius: 8,
  border: '1px solid #e5e7eb',
  background: '#fff',
  boxShadow: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)'
}));

export const ChipList = styled('div')({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 8,
  marginTop: 12
});

export const CompanyChip = styled('span')({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  padding: '2px 8px',
  borderRadius: 8,
  border: '1px solid #d5def6',
  background: '#fff',
  color: '#4b5563',
  fontSize: 12,
  fontWeight: 500,
  lineHeight: '16px'
});

export const ChipRemove = styled('button')({
  border: 0,
  background: 'transparent',
  padding: 0,
  cursor: 'pointer',
  color: '#9aa3b8',
  fontSize: 12,
  lineHeight: 1
});
